import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { EsnCandidatService } from './../../../../core/services/esn-candidat/esn-candidat.service';
import { Component, ElementRef, TemplateRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { translations } from './../../../../core/models/call-offer';
import { statusCandidate } from './../../../../core/models/candidat';
import {
  EmptyCV,
  obligationSelect,
  serverError,
} from './../../../../core/models/messages';
import {
  linkedInRegExp,
  patternEmail,
  patternfirstNamechiffre,
  patternNumbersOnly,
} from './../../../../core/models/pattern';
import { EsnConsultantService } from './../../../../core/services/esn-consultant/esn-consultant.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { SortDataService } from './../../../../core/services/sortdata';
import { Country, IState, State } from 'country-state-city';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import * as JSZip from 'jszip';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ExportService } from '@shared/services/export.service';
import { PageEvent } from '@angular/material/paginator';
import { ConsultantSelectedService } from '@core/services/esn-consultant/consultant-selected.service';
@Component({
  selector: 'app-intercontrat',
  templateUrl: './intercontrat.component.html',
  styleUrls: ['./intercontrat.component.css'],
})
export class IntercontratComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  btnSearchactive : boolean = false;
  freeSearch: boolean = false;
  listNames: string[] = [];
  dataHeader: any = [];
  loadSpinner: boolean = false;
  itemsPerPage: number = 5;
  currentPage: number = 0;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  currentSortDirection: number = 1;
  startIndex: number = 0;
  isButtonDisabled: boolean = false;
  endIndex: number = 5;
  totalItems!: number;
  listconsultant: any;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  searchForm: FormGroup = this.createSearchForm();
  freeSearchForm: FormGroup = this.createFreeSearchForm();
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  modalRef?: BsModalRef;
  clientSelected: boolean = false;
  statut = statusCandidate;
  client: any[] = [];
  candidat_id: any;
  stateList!: IState[];
  isexiste = false;
  isCollapsed = true;
  selectedconsultant: any;
  errorMessage: string = '';
  pagination : boolean =false;

  listclient: { id: number; name: string }[] = [];
  manager: any[] = [];
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  contratRequest = [

    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];

  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  checkboxState: {
    [key: string]: { displayName: string; isChecked: boolean };
  } = {
    Image: { displayName: 'Image', isChecked: true },
    Nom: { displayName: 'Nom', isChecked: true },
    Poste: { displayName: 'Poste', isChecked: true },
    Manager: { displayName: 'Manager', isChecked: true },
    Expérience: { displayName: 'Expérience', isChecked: true },
    Compétences: { displayName: 'Compétences', isChecked: true },
    TJMAchat: { displayName: 'TJM (achat)', isChecked: true },
    Salaire: { displayName: 'Salaire', isChecked: true },
    TJMVente: { displayName: 'TJM (vente)', isChecked: true },
    ContratSouhaité: { displayName: 'Contrat souhaité', isChecked: true },
    Pays: { displayName: 'Pays', isChecked: true },
    Ville: { displayName: 'Ville', isChecked: true },
    Tel: { displayName: 'N°Tel', isChecked: true },
    Email: { displayName: 'Email', isChecked: true },
    CV: { displayName: 'CV', isChecked: true },
    CVWegestU: { displayName: 'CV WegestU', isChecked: true },
    Score: { displayName: 'Score WeGestU', isChecked: true },
    Réponses: { displayName: 'Réponses', isChecked: true },

  };
  sortAttr: string = '';
  skillsList: { name_FR: string }[] = [];
  currentSortColumn: string = 'name'; // Initial column to sort by
  formconsultant: FormGroup = this.createconsultantForm();
  cvName: any;
  private unsubscribeAll: Subject<void> = new Subject();
  listmanager: {
    uuid: string; id: number; full_name: string, first_name: string, last_name: string 
}[] = [];

  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private esnconsultantservice: EsnConsultantService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private salarieservice: SalarieService,
    private candidatservice: EsnCandidatService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private modalService: BsModalService,
    private elRef: ElementRef,
    private exportService: ExportService,
    private consultantSelectedService: ConsultantSelectedService
  ) {}
  ngOnInit() {
    this.getListclient();
    this.getListmanager();
    this.getListconsultant();
    this.getListSkills();
    this.getListElementHeader();
    this.contrat = this.contrat.sort((a, b) => {
      return a.name === 'Autres type de contrat' ? 1 : b.name === 'Autres type de contrat' ? -1 : 0;
    });
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this
      .closeDropdownOnScroll.bind(this));

    this.formconsultant = this.formBuilder.group(
      {
        esn_id: ['', Validators.required],
        candidate_id: [''],
        first_name: ['', Validators.required],
        last_name: ['', Validators.required],
        email: [
          '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern(patternEmail),
          ],
        ],
        emailProESN: ['', [Validators.email, Validators.pattern(patternEmail)]],
        linkedin_link: ['',Validators.pattern(linkedInRegExp)],
        cv: [''],
        desired_workstation: [''],
        date_signature_contrat: [''],
        mission_start_date: [{ value: '', disabled: true }],
        mission_end_date: [{ value: '', disabled: true }],
        salary: ['', [Validators.pattern(patternNumbersOnly)]],
        tjm_achat: ['', [Validators.pattern(patternNumbersOnly)]],
        tjm_vente: ['', [Validators.pattern(patternNumbersOnly)]],
        manager_id: [''],
        client_id: [''],
      },
      { validators: this.dateRangeValidator }
    );

    this.formconsultant = this.createconsultantForm();
    this.formconsultant.get('client_id')?.valueChanges.subscribe((value) => {
      this.clientSelected = !!value;
      if (!this.clientSelected) {
        this.formconsultant.get('mission_start_date')?.disable();
        this.formconsultant.get('mission_end_date')?.disable();
      } else {
        this.formconsultant.get('mission_start_date')?.enable();
        this.formconsultant.get('mission_end_date')?.enable();
      }
    });
    this.formconsultant.get('linkedin_link')?.valueChanges
    .pipe(distinctUntilChanged())
    .subscribe(() => {
      this.setValidatorRequirements();
    });

  this.formconsultant.get('cv')?.valueChanges
    .pipe(distinctUntilChanged())
    .subscribe(() => {
      this.setValidatorRequirements();
    });
  this.setValidatorRequirements();
  }
  createFreeSearchForm(){
    return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  displayFreeSearch() {
    this.freeSearch = !this.freeSearch;
    this.currentPage = 0;
    if(this.freeSearch) {
       this.searchForm = this.createSearchForm();
       this.searchForm.reset();
       this.getListconsultant();
    }
    else {
      // this.freeSearchForm.reset();
      // this.freeSearchForm = this.createFreeSearchForm();
      this.getListconsultant();
    }
  }
  getListElementHeader() {
    this.esnconsultantservice.getHeaderElements(32)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.dataHeader = res.data;
          for (const iterator of this.dataHeader) {
            if (
              (iterator.checked == 'oui' && !iterator.checked_user) ||
              (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
              (iterator.checked == 'oui' && iterator.checked_user == 'oui')
            )
              this.listNames.push(iterator.name);
          }
          this.dataHeader.map((el: any) => {
            if (
              (el.checked == 'oui' && !el.checked_user) ||
              (el.checked_user == 'oui' &&
                (el.checked == 'non' || el.checked == 'oui'))
            ) {
              return (el.checkAdmin = true);
            } else {
              return (el.checkAdmin = false);
            }
          });
        },
        error: () => { },
      });
  }
  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    let payload = {
      sub_page_id: data?.id,
    };
    this.esnconsultantservice
      .changeDelectedElementHeader(payload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: () => { },
        error: () => { },
      });
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  setValidatorRequirements() {
    
    const linkedinControl = this.formconsultant.get('linkedin_link');
    const cvControl = this.formconsultant.get('cv');
  
    // Effacer les validateurs existants
    linkedinControl?.clearValidators();
    cvControl?.clearValidators();
  
    if (!linkedinControl?.value && !cvControl?.value) {
      linkedinControl?.setValidators([
        Validators.required,
        Validators.pattern(linkedInRegExp),
      ]);
      cvControl?.setValidators(Validators.required);
    } else {

      if (linkedinControl?.value) {
        linkedinControl?.setValidators([Validators.pattern(linkedInRegExp)]);
      }
      if (cvControl?.value) {
        cvControl?.clearValidators();
        // linkedinControl?.clearValidators();
      }
    }
  
    linkedinControl?.updateValueAndValidity({ emitEvent: false });
    cvControl?.updateValueAndValidity({ emitEvent: false });
  }
  dateRangeValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    const startDate = control.get('mission_start_date')!.value;
    const endDate = control.get('mission_end_date')!.value;

    if (startDate && endDate && startDate > endDate) {
      return { dateRangeInvalid: true };
    }

    return null;
  }
  filterColumns(columnName: string): boolean {
    return this.checkboxState[columnName]?.isChecked || false;
  }
  getCheckboxStateEntries(): [
    string,
    { displayName: string; isChecked: boolean }
  ][] {
    return Object.entries(this.checkboxState);
  }
  updateCheckboxState(columnName: string): void {
    const checkbox = this.checkboxState[columnName];
    if (checkbox) {
      checkbox.isChecked = !checkbox.isChecked;
    }
  }
  createconsultantForm(data?: any) {
    return this.formBuilder.group(
      {
        first_name: [
          data?.first_name || '',
          [Validators.required, Validators.pattern(patternfirstNamechiffre)],
        ],
        last_name: [
          data?.last_name || '',
          [Validators.required, Validators.pattern(patternfirstNamechiffre)],
        ],
        emailProESN: [
          data?.emailProESN || '',
          [Validators.pattern(patternEmail)],
        ],
        email: [
          data?.email || '',
          [Validators.required, Validators.pattern(patternEmail)],
        ],
        linkedin_link: [data?.linkedin_link || ''],
        cv: [data?.cv || ''],
        desired_workstation: [data?.desired_workstation || ''],
        date_signature_contrat: [data?.date_signature_contrat || ''],
        salary: [data?.salary || null],
        tjm_achat: [data?.tjm_achat || ''],
        tjm_vente: [data?.tjm_vente || ''],
        manager_id: [data?.manager_id || null],
        client_id: [data?.client_id?data?.client_id:data?.client_id2 || null],
        candidate_id: [data?.candidate_id || ''],
        esn_id: ['', [Validators.required]],
        mission_start_date: [{ value: '', disabled: true }],
        mission_end_date: [{ value: '', disabled: true }],
      },
      { validator: this.dateRangeValidator }
    );
  }
  reset() {
    this.stateList=[];
    this.searchForm.reset();
    this.freeSearchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
    this.searchForm = this.createSearchForm();
    this.getListconsultant();
  }

  sortData(item: string) {
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;

    if (this.searchForm.dirty)
      this.listconsultant = this.sortDataService.sortArray(
        this.listconsultant,
        item,
        this.currentSortDirection
      );
    else this.getListconsultant();
  }


  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchconsultantesn();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListconsultant();
      }
    }
  }
  onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.currentPage = e.pageIndex;
    if (this.searchForm.dirty && this.btnSearchactive) {
      this.searchconsultantesn();
    } 
    if (this.freeSearchForm.dirty && this.btnSearchactive) {
      this.searchconsultantesn();
    } 
    else {
      this.getListconsultant();
    }
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }
  getListconsultant() {
    this.spinner.show();
        const parasm = {
          per_page: this.pageSize,
          page: this.currentPage 
        }
    this.esnconsultantservice.getListintercontrat(parasm).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          this.listconsultant = response.data.data
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
        }
      },
      error: (error: any) => {
        this.spinner.hide();
      },
    });
  }


  ischecked = true;
  selectedCandidats: any = [];
  downloadFile(type: string, candidat?: any, typeFile?: string) {
    if (this.ischecked) {
      if (type == 'single' && candidat) {
        if (candidat.cv || candidat.file_test) {
          if (typeFile && typeFile != '')
            // .split('/')[1];
            candidat.file_test = candidat.file_test;
          const fileUrl = !typeFile
            ? `${this.url}/User/file/gallery_cvs/${candidat.cv}`
            : `${this.url}/ResponseCandidate/GetFile/${candidat.file_test}`; // Replace with your file URL
          this.showGlobalSpinner();
          this.candidatservice.downloadPDF(fileUrl).subscribe(
            (data) => {
              const blob = new Blob([data], {
                type: 'application/octet-stream',
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = !typeFile
                ? `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_CV.${candidat!.cv.split('.').pop()}`
                : `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_QCM.${candidat!.file_test.split('.').pop()}`;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              this.getListconsultant();
              this.hideGlobalSpinner();
            },
            () => {
              this.hideGlobalSpinner();
            }
          );
        } else {
          this.toastrService.info(EmptyCV);
        }
      } else if (this.selectedCandidats.length) {
        if (
          this.selectedCandidats.length == 1 &&
          !this.selectedCandidats[0].cv
        ) {
          this.toastrService.info(EmptyCV);
        } else this.downloadPdfFiles(typeFile);
      } else {
        this.toastrService.info(obligationSelect);
      }
    } else {
      this.toastrService.error(
        'Limite de téléchargements atteinte. Vous ne pouvez télécharger que 3 fichiers.'
      );
    }
  }
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }
  /* go to suggestion job offer */
  navigateToSuggestionJobOffer(id: number) {
    this.router.navigate([
      '/consultants/suggestion-jobOffer',
      { id: id },
    ]);
  }
  translateCountryName(name: string): string {
   
    return translations[name] || name;
  }
  /* go to suggestion job request */
  navigateToSuggestionJobRequest(id: number) {
    this.router.navigate([
      '/consultants/suggestion-jobRequest',
      { id: id },
    ]);
  }
  /* download files in zip folder */
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {
          // if(el.file_test!=null)
          return {
            url: `${this.url}/ResponseCandidate/GetFile/${
              el?.file_test?.split('/')[1]
            }`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test?.split('/')[1],
          };
        }
      }
    );
    this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_QCM.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          (err: any) => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip'); // Specify the zip file name here
        } else {
          saveAs(content, 'RH_Profiles_QCMs.zip');
        }
      });
    });
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      name: ['', data?.name],
      post: ['', data?.post],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      manager_name: ['', data?.manager_name],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm_vente: ['', data?.tjm_vente],
      tjm_vente_range: ['', data?.tjm_vente_range],
      tjm_achat: ['', data?.tjm_achat],
      tjm_achat_range: ['', data?.tjm_achat_range],
      max_experience_years: ['', data?.max_experience_years],
      min_experience_years: ['', data?.min_experience_years],
      mobility: [[], data?.mobility],
      current_country: [null, data?.current_country],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],

      per_page: this.itemsPerPage,
      page: this.currentPage,
    });
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }

  convertKToNumber(value: any) {
    if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
      return parseFloat(value.slice(0, -1)) * 1000;
    } else if (!isNaN(value)) {
      return parseFloat(value) * 1000;
    }
    return parseFloat(value);
  }
  /* search */
  searchconsultantesn(pageNumber : number = this.currentPage) {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(
      valueForm.desired_salary_range.toString()
    );
    let data = {
      name: valueForm.name,
      post: valueForm.post,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      manager_name: valueForm.manager_name,
      // client_final_name:valueForm.client_final_name,
      tjm_achat: valueForm.tjm_achat,
      tjm_achat_range: valueForm.tjm_achat_range,
      tjm_vente: valueForm.tjm_vente,
      tjm_vente_range: valueForm.tjm_vente_range,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      max_experience_years: valueForm.max_experience_years,
      min_experience_years: valueForm.min_experience_years,
      mobility: valueForm.mobility,
      current_country: valueForm.current_country,
      per_page: this.pageSize,
      page: this.currentPage,
      search: this.transformSearch(valueForm?.search),
    };

    this.spinner.show();
    this.esnconsultantservice
      .searchintercontrat(data)
      .subscribe({
        next: (resSearch) => {
          this.listconsultant = resSearch.data.data;
          this.totalItems = resSearch.data.total;
          this.spinner.hide();
        },
        error: (error) => {
          this.toastrService.error(serverError);
          this.spinner.hide();
        },
      });
  }
  ////////////////////////////////////////////////////////////////////////////////////
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }




  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }
  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.searchForm.get('mobility')?.setValue(null);
    }
  }
  dissocierconsultant(uuid: any) {
    let formdata = new FormData();
    formdata.append('candidate_id', uuid);
    Swal.fire({
      title: 'Voulez-vous vraiment dissocier ce consultant ? <br> La dissociation entraîne le verrouillage des CRA pour le mois en cours.',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.esnconsultantservice
          .dissocierconsultant(formdata)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res: any) => {
              this.searchconsultantesn();
            },
            error: () => {
              this.spinner.hide();
            },
          });
      }
    });
  }
  isnull: boolean = false;
  openModal(template: TemplateRef<any>, data?: any, mode?: string) {
    if (data.cv === 'null') {
      this.isnull = true;
    } else {
      this.isnull = false;
    }

    this.formconsultant.get('email')?.setValue('');
    this.formconsultant = this.createconsultantForm(data);
    const salary = this.formconsultant.get('salary');
    if (salary && data && data.consultant_e_s_n_Salary) {
      salary.setValue(data.consultant_e_s_n_Salary);
    }
    const tjm_achat = this.formconsultant.get('tjm_achat');
    if (tjm_achat && data && data.consultant_e_s_n_Tjm_achat) {
      tjm_achat.setValue(data.consultant_e_s_n_Tjm_achat);
    }
    const tjm_vente = this.formconsultant.get('tjm_vente');
    if (tjm_vente && data && data.consultant_e_s_n_Tjm_vente) {
      tjm_vente.setValue(data.consultant_e_s_n_Tjm_vente);
    }
    this.formconsultant.get('client_id')?.setValue(data.client_id?data.client_id:data.client_id2);


    if (this.listmanager.length > 0) {
      const manager = this.listmanager.filter( el => el.uuid == data.manager_id);
      if (manager) {
        this.formconsultant.get('manager_id')?.setValue(manager[0]?.uuid);
       
      }
    }
    this.formconsultant.get('client_id')?.valueChanges.subscribe((value) => {
      this.clientSelected = !!value;
      if (!this.clientSelected) {
        this.formconsultant.get('mission_start_date')?.disable();
        this.formconsultant.get('mission_end_date')?.disable();
      } else {
        this.formconsultant.get('mission_start_date')?.enable();
        this.formconsultant.get('mission_end_date')?.enable();
      }
    });

    this.formconsultant.get('linkedin_link')?.enable();

    this.formconsultant.get('mission_start_date')?.enable();
    this.formconsultant.get('mission_end_date')?.enable();
    this.formconsultant
      .get('date_signature_contrat')
      ?.setValue(data.consultant_e_s_n[0].date_signature_contrat);
    this.formconsultant
      .get('mission_start_date')
      ?.setValue(data.consultant_e_s_n[0].mission_start_date);
    this.formconsultant
      .get('mission_end_date')
      ?.setValue(data.consultant_e_s_n[0].mission_end_date);
    this.formconsultant.get('candidate_id')?.setValue(data.uuid);
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }
  closeModal() {
    this.formconsultant.reset();
    this.selectedconsultant = '';
    this.cvName = '';
    this.isButtonDisabled = false;
    this.errorMessage = '';
    this.modalRef!.hide();
  }
  getListclient() {
    this.esnconsultantservice.getclient().subscribe({
      next: (response) => {
        if (response.data) {
          this.listclient = response.data;
          this.client = response.data;
        }
      },
      error: (error) => {
      },
    });
  }
  getListmanager() {
    this.esnconsultantservice.getmanagernew().subscribe({
      next: (response) => {
        if (response.data) {
          this.listmanager = response.data.map((el: any) => {
            return {
              ...el,
              full_name: `${el.first_name} ${el.last_name}`
            };
          });          
        }
      },
      error: (error) => {
      },
    });
  }
  isDateRangeValid(): boolean {
    return !this.formconsultant.hasError('dateRangeInvalid');
  } 
  updateConsultant() {
    const updatedValues: any = {};
  
    // Convertir les valeurs en chaînes, y compris pour les valeurs nulles
    updatedValues.tjm_vente = this.formconsultant.value.tjm_vente ? this.formconsultant.value.tjm_vente.toString() : '';
    updatedValues.tjm_achat = this.formconsultant.value.tjm_achat ? this.formconsultant.value.tjm_achat.toString() : '';
    updatedValues.salary = this.formconsultant.value.salary ? this.formconsultant.value.salary.toString() : '';
  
    // Patcher le formulaire avec les valeurs mises à jour
    this.formconsultant.patchValue(updatedValues);
  
    // Ne pas supprimer les clés, mais laisser les valeurs vides si null ou "null"
    const cleanedValues = Object.entries(this.formconsultant.value)
      .reduce((acc: any, [key, value]) => {
        acc[key] = value !== null && value !== 'null' ? value : '';
        return acc;
      }, {});
    
    this.esnconsultantservice
      .updateConsultant(
        cleanedValues.candidate_id,
        cleanedValues
      )
      .subscribe((res: any) => {
        this.toastrService.success('Consultant a été modifié avec succès');
        this.closeModal();
        this.getListconsultant();
      });
  }

  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }

  //@TOFIX: duplicated
  /**
   * Returns a string list of skills for tooltip display.
   * @param contractTypes - An array of skills.
   * @returns A string listing the skills names.
   */
   getSkillsList(skillsList: string[]): string {
    if(Array.isArray(skillsList))  return skillsList.map(skill => skill).join(', ');
    else return ''
  }

  //@TOFIX: duplicated
   /**
   * Returns a string list of contract types for tooltip display based on contract type codes.
   * @param contractTypes - An array of contract type codes.
   * @returns A string listing the contract type names.
   */
   getContractTypeList(contractTypes: number[]): string {
    const contractMap: { [key: string]: string } = {
        '1': 'Alternance',
        '2': 'Autres type de contrat',
        '3': 'CDD',
        '4': 'CDI',
        '5': 'Freelance',
        '6': 'Portage salarial',
        '7': 'Stage'
    };

    return contractTypes.map(type => contractMap[type.toString()] || '').join(', ');
  }

// @TOFIX: duplicated
/**
* Exports the CV of a candidate based on the specified type and company ID.
*
* @param {any} candidate - The selected candidate
* @param {number} type - The type of CV to export (e.g., 1 for standard, 2 for anonymous)
* @param {number | null} idCompany - The ID of the company for which the CV is being exported.
*                          Use `null` if no specific company is associated.
*/
exportCVCandidate( candidat: any, type: number, idCompany : number | null) {
  this.spinner.show();
  const candidate = {
    ids: [candidat.uuid],
    last_name: candidat?.last_name,
    first_name: candidat?.first_name
  } 
  const exportMethod = idCompany !== null
    ? this.exportService.exportCVEsnCandidate(candidate, type, idCompany)
    : this.exportService.exportCVWegestuCandidate(candidate, type);

  exportMethod.subscribe({
    next: () => {
      this.spinner.hide();
    },
    error: () => {
      this.spinner.hide();
    },
  });
  }

  updateNavigation(consultant: any) {
    this.consultantSelectedService.setConsultantSelected(consultant);
    this.router.navigate(['consultants/modification-consultant/', { type: 2 }]);
  }
}
